<script setup lang="ts">
const { customSealsOnPatronages } = useLicenses();

const customSigmaSealSize = (seal: { size: string }): string => {
  return seal.size || '120';
};
</script>

<template>
  <div
    class="flex justify-center items-center gap-4 md:gap-6 2xl:justify-start"
  >
    <FooterItemsSeals
      v-for="(custom, i) in customSealsOnPatronages"
      :id="custom?.id || i"
      :key="i"
      :href="custom?.href"
      :size="customSigmaSealSize(custom)"
      :src="custom?.src"
      :type="custom?.type"
    />
  </div>
</template>
